
<div class="tis-login-page">
  <ng-container *transloco="let t; read: 'resetPassword'">
    <div class="container-fluid">
      <!-- Desktop View -->
      @if (!isMobile) {
        <div class="grid grid-cols-12 gap-3 flex items-center desktop" style="height: 100%;">
          <div class="col-span-12 pd-0 login-1" style="box-shadow: 0px 0px 9px 3px #9e9e9e; border-radius: 10px;">
            <div class="w-full flex justify-center items-center">
              <div class="w-full main2 mt-0 tis-login-container" style="border-radius: 10px;">
                <div class="grid grid-cols-12 gap-3 main-box-box w-full">
                  <!-- Left Banner -->
                  <div class="md:col-span-6 sm:col-span-6 col-span-12 pd-0 right-box">
                    <img [src]="themeConfig.logos.banner.img" alt="banner" class="w-full"
                      style="border-radius: 10px 0px 0px 10px; height: 100%;">
                  </div>
                  <!-- Right Form -->
                  <div
                    class="md:col-span-6 sm:col-span-6 col-span-12 text-center p-5 pl-0 relative flex flex-col justify-between">
                    <!-- Language Selection -->
                    <div class="w-full tis-language-selection flex justify-between items-center mb-5">
                      <a class="navbar-brand tis-curser-pointer inline-flex items-center"
                        [style.color]="themeConfig.bgAndFontColor.login.desktop?.heading"
                        [style.font-family]="themeConfig.bgAndFontColor.login.desktop.font">
                        <mat-icon style="font-size: 26px;">phone</mat-icon>
                        <span style="font-size: 24px;">&nbsp;: 02-266-9058</span>
                      </a>
                      <ul class="langFlag flex space-x-2">
                        <li>
                          <a (click)="changeActiveLanguage('en')" class="tis-curser-pointer">
                            <img src="/assets/icons/en.png" alt="EN"
                              style="width: 30px; height: 30px; border-radius: 30px;">
                          </a>
                        </li>
                        <li>
                          <a (click)="changeActiveLanguage('th')" class="tis-curser-pointer">
                            <img src="/assets/icons/th.png" alt="TH"
                              style="width: 30px; height: 30px; border-radius: 30px;">
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- Password Reset Form -->
                    <div class="w-full p-3 form-box">
                      <h5 class="text-2xl font-semibold mb-4">
                        {{ t('title') }}
                      </h5>
                      <p class="mb-3 text-gray-600">
                        {{ t('resetPasswordMessage') }}
                      </p>
                      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                        <mat-form-field appearance="outline" class="w-full mb-3">
                          <input type="password" matInput style="height: 30px;"
                            [placeholder]="t('enterNewPassword')" formControlName="newPassword"
                            required>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-full mb-3">
                          <input type="password" matInput style="height: 30px;"
                            [placeholder]="t('enterConfirmPassword')"
                            formControlName="confirmPassword" required>
                        </mat-form-field>
                        <button type="submit" mat-raised-button
                          style="background-color: rgb(195, 33, 36); color: white;"
                          class="w-full">
                          {{ t('submit') }}
                          @if (loading) {
                            <i class="fas fa-spinner fa-spin"></i>
                          }
                        </button>
                      </form>
                  </div>
                  <!-- Error Message -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Mobile View -->
    @if (isMobile) {
      <div class="p-3 flex flex-col items-center justify-center">
        <div class="w-full max-w-md bg-white shadow-lg rounded-lg p-5">
          <!-- Language Selection -->
          <div class="w-full flex justify-between items-center mb-4">
            <a class="tis-curser-pointer inline-flex items-center"
              [style.color]="themeConfig.bgAndFontColor.login.desktop?.heading"
              [style.font-family]="themeConfig.bgAndFontColor.login.desktop.font">
              <mat-icon style="font-size: 22px;">phone</mat-icon>
              <span style="font-size: 18px;">&nbsp;: 02-266-9058</span>
            </a>
            <ul class="flex space-x-2">
              <li>
                <a (click)="changeActiveLanguage('en')" class="tis-curser-pointer">
                  <img src="/assets/icons/en.png" alt="EN"
                    style="width: 24px; height: 24px; border-radius: 24px;">
                </a>
              </li>
              <li>
                <a (click)="changeActiveLanguage('th')" class="tis-curser-pointer">
                  <img src="/assets/icons/th.png" alt="TH"
                    style="width: 24px; height: 24px; border-radius: 24px;">
                </a>
              </li>
            </ul>
          </div>
          <!-- Reset Password Form -->
          <div class="w-full">
            <p class="mb-3 text-gray-600 text-center">
              {{ t('resetPasswordMessage') }}
            </p>
            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
              <mat-form-field appearance="outline" class="w-full mb-3">
                <input type="password" matInput style="height: 30px;"
                  [placeholder]="t('enterNewPassword')" formControlName="newPassword" required>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-full mb-3">
                <input type="password" matInput style="height: 30px;"
                  [placeholder]="t('enterConfirmPassword')" formControlName="confirmPassword"
                  required>
              </mat-form-field>
              <button type="submit" mat-raised-button
                style="background-color: rgb(195, 33, 36); color: white;" class="w-full">
                {{ t('submit') }}
                @if (loading) {
                  <i class="fas fa-spinner fa-spin"></i>
                }
              </button>
            </form>
        </div>
      </div>
    </div>
  }
</div>

</ng-container>
</div>